function determineFileType(fileKey) {
    // Common video and image extensions
    const videoExtensions = [".mp4", ".mov", ".avi", ".mkv", ".wmv"];
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  
    // Extract the file extension from the Key
    const extension = fileKey.slice(fileKey.lastIndexOf(".")).toLowerCase();
  
    // Check if it's a video
    if (videoExtensions.includes(extension)) {
      return "video";
    }
  
    // Check if it's an image
    if (imageExtensions.includes(extension)) {
      return "image";
    }
  
    // Return unknown if the extension doesn't match known types
    return "unknown";
  }

export default determineFileType